"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
    AR: [
        'يناير',
        'فبراير',
        'مارس',
        'إبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمير',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
    ],
};
